import { createActionCreator } from 'deox';

export const getDefaultApisActions = {
  request: createActionCreator('GET_DEFAULT_APIS_REQUEST', (resolve) => (organisationId: string) =>
    resolve({ organisationId }),
  ),
  success: createActionCreator('GET_DEFAULT_APIS_SUCCESS', (resolve) => () => resolve()),
  failure: createActionCreator('GET_DEFAULT_APIS_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const reloadDefaultEntityActions = {
  request: createActionCreator(
    'RELOAD_DEFAULT_ENTITY_REQUEST',
    (resolve) => (organisationId: string, type: string) => resolve({ organisationId, type }),
  ),
  success: createActionCreator('RELOAD_DEFAULT_ENTITY_SUCCESS', (resolve) => () => resolve()),
  failure: createActionCreator('RELOAD_DEFAULT_ENTITY_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};
